// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3GgJ3","button--green":"Button_button--green__3KkEJ","button--info":"Button_button--info__3OMeA","button--primary":"Button_button--primary__1XpDF"};